import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import Today from "@/pages/today/page";
import Rank from "@/pages/rank/page";
import Recommend from "@/pages/recommend/page";
import ComicDetail from "@/pages/comic/[id]/page";
import About from "@/pages/about/page";
import Contact from "@/pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/today",
    element: <Today />,
  },
  {
    path: "/rank",
    element: <Rank />,
  },
  {
    path: "/recommend",
    element: <Recommend />,
  },
  {
    path: "/comic/:id",
    element: <ComicDetail />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;